import React from 'react';
import { Flame, Mountain, Users } from 'lucide-react';

export const ElOficio = () => {
  const techniques = [
    {
      icon: Mountain,
      title: 'El Rodete',
      description: 'Cada pieza nace del movimiento circular de manos expertas que enrollan cilindros de arcilla uno sobre otro.'
    },
    {
      icon: Flame,
      title: 'Fuego Abierto',
      description: 'Las piezas se cuecen en piras a fuego abierto. Las llamas y el humo les dan las tonalidades únicas que identifican la cerámica de El Cercado.'
    },
    {
      icon: Users,
      title: 'Transmisión Oral',
      description: 'El oficio no se enseña en libros. Se aprende viendo, escuchando, haciendo. De generación en generación.'
    }
  ];

  return (
    <section id="el-oficio" className="section-padding bg-cal-darker">
      <div className="editorial-container">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="nav-label text-siena">El Oficio</span>
          <h2 className="display-heading text-4xl md:text-5xl lg:text-6xl text-earth mt-4 mb-6">
            El arte de
            <br />
            <span className="text-ochre">moldear el tiempo</span>
          </h2>
          <p className="body-text text-lg">
            Un proceso sin cambios desde hace cinco siglos. Meticuloso, ritual, vivo.
          </p>
        </div>

        {/* Technique Cards */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {techniques.map((technique, index) => {
            const Icon = technique.icon;
            return (
              <div
                key={index}
                className="bg-background rounded-lg p-8 shadow-md hover:shadow-xl transition-all duration-300 group"
              >
                <div className="w-14 h-14 rounded-full bg-siena/10 flex items-center justify-center mb-6 group-hover:bg-siena/20 transition-colors">
                  <Icon className="w-7 h-7 text-siena" />
                </div>
                <h3 className="display-heading text-2xl text-earth mb-3">
                  {technique.title}
                </h3>
                <p className="body-text text-base leading-relaxed">
                  {technique.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Process Image */}
        <div className="flex flex-col md:grid md:grid-cols-5 gap-4">
          {/* Foto Vertical - Ventana */}
          <div className="md:col-span-2">
            <img
              src="/images/ventana_taller.jpg"
              alt="Ventana del taller con piezas"
              className="w-full h-[400px] md:h-[516px] object-cover rounded-lg shadow-xl"
              style={{ objectPosition: 'center 5%' }}
              loading="lazy"
            />
          </div>
          
          {/* Dos Fotos Horizontales */}
          <div className="flex flex-col md:col-span-3 gap-4">
            <div className="h-[300px] md:h-[250px]">
              <img
                src="https://images.unsplash.com/photo-1675101337462-a19b63af8b1b"
                alt="Proceso de moldeado con técnica rodete"
                className="w-full h-full object-cover rounded-lg shadow-lg"
                loading="lazy"
              />
            </div>
            <div className="h-[300px] md:h-[250px]">
              <img
                src="https://images.unsplash.com/photo-1546006200-f8c574598b28"
                alt="Manos trabajando la arcilla"
                className="w-full h-full object-cover rounded-lg shadow-lg"
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Quote */}
        <div className="mt-16 max-w-3xl mx-auto text-center">
          <blockquote className="display-heading text-2xl md:text-3xl text-earth italic leading-relaxed">
            "Así nos hizo Dios, del mismo barro, pero diferentes. La mano del alfarero es Dios y el barro somos nosotros."
          </blockquote>
          <p className="mt-4 text-stone text-sm uppercase tracking-wider">— Juan José Bermúdez</p>
        </div>
      </div>
    </section>
  );
};
